import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';

export const HeringStandardSchema = (settings) => (
    Yup.object()
        .concat(DocumentsSchema(settings))
        .concat(NameAndContactSchema(settings))
);

export const HeringStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}